import { useEffect, useRef } from 'react'
import { useState } from 'react'
import Select from 'react-select';
import { get, post } from '../../services/api'
import { TailSpin } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import { logout } from "../../auth";

function Filtros({ onFiltrarClick, dadosCarregados, cargoChange, mesAnoChange }) {
    const navigate = useNavigate();

    const [regioes, setRegioes] = useState(null);
    const [filtroRegiao, setFiltroRegiao] = useState(null);
    const [filiais, setFiliais] = useState(null);
    const [filtroFilial, setFiltroFilial] = useState(null);
    const [vendedores, setVendedores] = useState(null);
    const [filtrarAutomatico, setFiltrarAutomatico] = useState(null);
    const [filtroVendedor, setFiltroVendedor] = useState(null);
    const [isFetchingData, setIsFetchingData] = useState(false);

    const [mesSelecionado, setMesSelecionado] = useState(null);

    const [campoPesquisavel, setCampoPesquisavel] = useState(true);
    const [disabledFiltroRegiao, setDisabledFiltroRegiao] = useState(false);

    const buttonRef = useRef(null); // Ref para o botão de filtrar

    const UsuarioMaster = 1;
    const Vendedor = 2;
    const Gerente = 3;
    const GerenteRegional = 4;

    useEffect(() => {
        carregarFiltros();
    }, []);

    useEffect(() => {
        handleFiltrarButtonClick();
    }, [filtrarAutomatico]);

    function handleFiltrarButtonClick() {
        if (filtroVendedor){
            onFiltrarClick(parseInt(filtroVendedor.value), mesSelecionado.value, parseInt(filtroRegiao.value));
            localStorage.setItem('filtroTemporarioMesAno', JSON.stringify(mesSelecionado));
        }

    }

    async function PermissaoUsuario() {
        const idDepartamentoUsuario = localStorage.getItem("iddepartamentousuario");
        const idUsuario = localStorage.getItem("idusuario");

        try {
            const permissoes = await get(`/permissoes?usuario=${idUsuario}&departamento=${idDepartamentoUsuario}`)

            for (const permissao of permissoes)
                switch (permissao.id_tipo) {
                    case 1: return UsuarioMaster
                    case 2: return Gerente
                    case 3: return Vendedor
                    case 4: return GerenteRegional
                }

            //Usuario não tem permissão valida, logo deve voltar ao login
            logout();
            navigate("/login");

        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function carregarFiltros() {
        const idFilialUsuario = localStorage.getItem("idfilialusuario");
        const nomeFilial = localStorage.getItem("nomefilialusuario");

        const filtroTemporarioMesAno = JSON.parse(localStorage.getItem('filtroTemporarioMesAno'));
        const carregarFiltrosTemporarios = localStorage.getItem('carregarFiltrosTemporarios');

        const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth() + 1;
        const anoAtual = dataAtual.getFullYear();

        const mesAnoPadrao = {
            value: `${mesAtual}-${anoAtual}`,
            label: `${meses[mesAtual - 1]}/${anoAtual}`
        };

        const filtroMesAno = (carregarFiltrosTemporarios && filtroTemporarioMesAno) ? filtroTemporarioMesAno : mesAnoPadrao;

        setMesSelecionado(filtroMesAno);
        mesAnoChange(filtroMesAno.value);

        if (await PermissaoUsuario() == UsuarioMaster) {
            const regioes = await fetchRegioes(0);
            setRegioes(regioes);
        }

        if (await PermissaoUsuario() == Vendedor) {
            const regioes = await fetchRegioes(idFilialUsuario);

            if (Array.isArray(regioes) && regioes && regioes[0] && regioes !== undefined) {
                setFiltroRegiao({ value: regioes[0].id_regiao, label: regioes[0].nome_regiao });
            } else {
                setFiltroRegiao({ value: -1, label: '' });
            }

            let filiais = [{ cod_sabium: idFilialUsuario, nome: nomeFilial }];

            setFiliais(filiais);
            setFiltroFilial({ value: idFilialUsuario, label: idFilialUsuario - 10000 + ' - ' + nomeFilial });

            const idVendedor = localStorage.getItem("idvendedorusuario");
            const nomeVendedor = localStorage.getItem("usuariologado");

            cargoChange('VENDEDOR', idVendedor);

            let vendedores = [{ idvendedor: idVendedor, nome: nomeVendedor }];
            setVendedores(vendedores);
            setFiltrarAutomatico(idVendedor);
            setFiltroVendedor({ value: idVendedor, label: nomeVendedor, cargo: 'VENDEDOR' });

            setCampoPesquisavel(false);
            setDisabledFiltroRegiao(true);
        }

        if (await PermissaoUsuario() == Gerente) {
            const regioes = await fetchRegioes(idFilialUsuario);

            if (Array.isArray(regioes) && regioes && regioes[0] && regioes !== undefined) {
                setFiltroRegiao({ value: regioes[0].id_regiao, label: regioes[0].nome_regiao });
                setRegioes(regioes);
            } else {
                setFiltroRegiao({ value: -1, label: '' });
                setDisabledFiltroRegiao(true);
            }

            let filiais = [{ cod_sabium: idFilialUsuario, nome: nomeFilial }];

            setFiliais(filiais);
            setFiltroFilial({ value: idFilialUsuario, label: idFilialUsuario - 10000 + ' - ' + nomeFilial });

            const idVendedor = localStorage.getItem("idvendedorusuario");
            const nomeVendedor = localStorage.getItem("usuariologado");

            cargoChange('GERENTE_LOJA', idVendedor);
            setFiltrarAutomatico({ value: idVendedor, label: nomeVendedor });

            setFiltroVendedor({ value: idVendedor, label: nomeVendedor.toUpperCase() + ' (GERENTE)', cargo:'GERENTE_LOJA' });

            fetchVendedores(idFilialUsuario);

            setCampoPesquisavel(true);
        }

        if (await PermissaoUsuario() == GerenteRegional) {
            const idUsuario = localStorage.getItem('idusuario');

            const regioes = await fetchRegioesGerenteRegional(idUsuario);

            if (Array.isArray(regioes)) {

                setRegioes(regioes);

                const idRegiao = regioes[0].id_regiao;
                const nomeRegiao = regioes[0].nome_regiao;

                setFiltroRegiao({ value: idRegiao, label: nomeRegiao });

                const filtrarRegionalAutomatico = (regioes.length > 1) ? false : true;

                fetchGerenteRegionalRegiao(idRegiao, filtrarRegionalAutomatico);

                fetchFiliais(idRegiao);
            }
        }

        localStorage.removeItem('carregarFiltrosTemporarios');
    }

    async function fetchRegioesGerenteRegional(idUsuario) {
        const requisicao = { idUsuario: idUsuario }
        const regioes = await post('/vendedores/regioesgerenteregional', requisicao);
        return regioes;
    }

    async function fetchRegioes(idFilialUsuario) {
        const idFilial = idFilialUsuario;
        const requisicao = { idFilial: idFilial }
        const regioes = await post('/vendedores/regioes', requisicao);
        return regioes;
    }

    async function fetchFiliais(regiaoSelecionada) {
        const requisicao = { idRegiao: regiaoSelecionada }
        const filiais = await post('/vendedores/filiais', requisicao);
        setFiliais(filiais);
    }

    async function fetchGerenteRegionalRegiao(regiaoSelecionada, filtrarAutomatico = false) {
        const requisicao = { idRegiao: regiaoSelecionada }

        setIsFetchingData(true);

        const gerenteRegional = await post('/vendedores/gerenteregionalregiao', requisicao);

        setIsFetchingData(false);

        if (gerenteRegional && gerenteRegional[0]) {
            const idVendedor = gerenteRegional[0].idvendedor;
            const nome = gerenteRegional[0].nome;

            setFiltroVendedor({ value: idVendedor, label: nome, cargo: 'GERENTE_REGIONAL' });
            cargoChange('GERENTE_REGIONAL', regiaoSelecionada);
            if (filtrarAutomatico) {
                setFiltrarAutomatico({ value: idVendedor, label: nome });
            }
        }

        setVendedores(gerenteRegional);
    }

    async function fetchVendedores(filialSelecionada) {
        const requisicao = { idFilial: filialSelecionada }

        setIsFetchingData(true);

        const vendedores = await post('/vendedores/vendedores', requisicao);

        setIsFetchingData(false);

        setVendedores(vendedores);
    }

    const handleChangeRegiao = async (selectedOption) => {
        if (await PermissaoUsuario() == UsuarioMaster || await PermissaoUsuario() == GerenteRegional) {
            cargoChange('GERENTE_REGIONAL', selectedOption);
            setFiliais([]); // Se a opção de região for limpa, limpa também as opções de filiais
            setFiltroFilial(null);
            setVendedores([]);
            setFiltroVendedor(null);
            setFiltroRegiao(selectedOption);
            if (selectedOption) {
                fetchFiliais(selectedOption.value); // Atualiza as filiais com base na região selecionada
                fetchGerenteRegionalRegiao(selectedOption.value);
            }
        }
    };

    const handleChangeFilial = async (selectedOption) => {
        if (await PermissaoUsuario() == UsuarioMaster || await PermissaoUsuario() == GerenteRegional) {
            setVendedores([]);
            setFiltroVendedor(null);
            setFiltroFilial(selectedOption);
            if (selectedOption) {
                fetchVendedores(selectedOption.value); // Atualiza os vendedores com base na filial selecionada
            } else {
                fetchGerenteRegionalRegiao(filtroRegiao.value);
            }
        }
    };

    const handleChangeVendedor = (selectedOption) => {
        setFiltroVendedor(selectedOption);
        if (selectedOption) {
            cargoChange(selectedOption.cargo, selectedOption.value)
        }
    };

    const handleChangeMes = (selectedOption) => {
        setMesSelecionado(selectedOption);
        if (selectedOption) {
            mesAnoChange(selectedOption.value);
            localStorage.setItem('filtroTemporarioMesAno', JSON.stringify(selectedOption));
        }
    };

    const optionsMeses = () => {
        const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth() + 1;
        const anoAtual = dataAtual.getFullYear();

        const options = [];

        const maximoMesesFiltro = 2;
        for (let i = 0; i < maximoMesesFiltro; i++) {
            let mes = mesAtual - i;
            let ano = anoAtual;

            if (mes <= 0) {
                mes += 12;
                ano -= 1;
            }

            const mesLabel = meses[mes - 1]; // Subtrai 1 para compensar o índice baseado em zero
            const optionValue = `${mes}-${ano}`;
            const optionLabel = `${mesLabel}/${ano}`;
            options.unshift({ value: optionValue, label: optionLabel });
        }

        return options;
    }

    const optionsRegioes = Array.isArray(regioes) ? regioes.map((regiao) => ({
        value: regiao.id_regiao,
        label: regiao.nome_regiao,
    })) : [];


    const optionsFiliais = Array.isArray(filiais) ? filiais.map((filial) => ({
        value: filial.cod_sabium,
        label: filial.cod_sabium - 10000 + ' - ' + filial.nome,
    })) : [];

    const optionsVendedores = Array.isArray(vendedores) ? vendedores.map((vendedor) => ({
        value: vendedor.idvendedor,
        label: vendedor.nome,
        cargo: vendedor.cargo
    })) : [];

    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';

    return (
        <div className="flex md:items-center justify-between lg:justify-center gap-1 lg:gap-4 mx-4 font-mulish font-medium text-sm flex-wrap lg:flex-nowrap flex-col md:flex-row">
            <p className="font-poppins font-semibold text-base text-white pr-2">Filtrar: </p>
            <div className="select-container">
                <Select
                    name="regiao"
                    className="react-select"
                    classNamePrefix="react-select"
                    value={filtroRegiao}
                    onChange={handleChangeRegiao}
                    options={optionsRegioes}
                    isSearchable={campoPesquisavel}
                    isClearable={campoPesquisavel}
                    isDisabled={disabledFiltroRegiao}
                    placeholder="Digite a região"
                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                />
            </div>
            <div className="select-container">
                <Select
                    name="filial"
                    className="react-select"
                    classNamePrefix="react-select"
                    value={filtroFilial}
                    onChange={handleChangeFilial}
                    options={optionsFiliais}
                    isSearchable={campoPesquisavel}
                    isClearable={campoPesquisavel}
                    placeholder="Selecione a filial"
                    isDisabled={!campoPesquisavel}
                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                />
            </div>
            <div className="select-container">
                <Select
                    name="vendedor"
                    className="react-select"
                    classNamePrefix="react-select"
                    onChange={handleChangeVendedor}
                    value={filtroVendedor}
                    options={optionsVendedores}
                    isClearable={campoPesquisavel}
                    isSearchable={campoPesquisavel}
                    placeholder={isFetchingData ? 'Carregando...' : 'Selecione o vendedor'}
                    isDisabled={isFetchingData || !campoPesquisavel}
                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                />
            </div>
            <div className="select-container">
                <Select
                    name="mes"
                    className="react-select"
                    classNamePrefix="react-select"
                    value={mesSelecionado}
                    onChange={handleChangeMes}
                    options={optionsMeses()}
                    isClearable={false}
                    isSearchable={false}
                    placeholder="Selecione o mês"
                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                />
            </div>
            <button ref={buttonRef} onClick={handleFiltrarButtonClick} className="bg-gray-c2 rounded text-white h-10 px-6" disabled={!dadosCarregados}>
                {dadosCarregados ? (
                    "Atualizar"
                ) : (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <TailSpin color="#ffffff" height={24} width={59} />
                    </div>
                )}
            </button>
        </div>
    )
}

export default Filtros